export const ELEMENT_NODE = 1;
